import React, { useContext, useEffect, useState } from 'react';
import { Col, Form, Row, Select, Space, DatePicker, Divider, Input } from 'antd';
import ButtonLink from 'components/theme_components/ButtonLink';
import { CarOutlined, ExclamationCircleOutlined, NumberOutlined } from '@ant-design/icons';
import GetLabel from 'DisplayFramework/components/GetLabel';
import IBasket from 'icons/IBasket';
import ConfirmModal from 'components/theme_components/ThirdParty/ConfirmModal';
import { AuthContext } from 'components/Auth/Auth';
import FormInput from 'components/FormInput';
import ProductInput from 'pages/ProposalV3/PropDetail/ProductInput';
import ProductConversionRuleInput from 'pages/ProposalV3/PropDetail/ProductConversionInput';
import { isBeforeDate, toDatePickerDate } from 'utils/utilsSFS';
import moment from 'moment';
import { FormInstance } from 'antd/lib';


type ConversionModalProps = {
  setVisible: (visible: boolean) => void;
  setmodalVisibleConfirmVisible: (visible: boolean) => void;
  mode: 'create' | 'modify';
  dataInput: any;
  form: FormInstance;
};

const ConversionModal: React.FC<ConversionModalProps> = ({
  setVisible,
  mode,
  dataInput,
  setmodalVisibleConfirmVisible,
  form
}) => {
  const [modalVisibleDelet, setmodalVisibleDelet] = useState(false);
  const { isInspect } = useContext(AuthContext);

  useEffect(() => {
    form.setFieldsValue({
      event: 'tabconvertcontract',

    })

  }, [mode, dataInput, form]);

  // const handleSubmit = async () => {
  //   try {
  //     const values = await form.validateFields();
  //     console.log('Form values:', values);
  //     setVisible(false);
  //     setmodalVisibleConfirmVisible(true);
  //   } catch (error) {
  //     console.error('Validation failed:', error);
  //   }
  // };

  // const handleDelete = () => {
  //   console.log('Delete conversion request');
  //   setVisible(false);
  // };

  return (
    <Form
      form={form}
      layout="vertical"
      className="p-6 bg-white rounded-lg shadow-md mb-10"
    >
      {/* Informations du véhicule */}
      <div className="mb-6">
        <Row gutter={16} align="middle" className="mb-4">
          <Col span={2} className="text-center">
            <NumberOutlined className="text-2xl text-gray-400" />
          </Col>
          <Col span={22}>
            <p className="text-sm text-gray-500 mb-1"><GetLabel label="VIN" /></p>
            <p className="text-lg font-semibold">{dataInput?.assets[0].chassisno}</p>
          </Col>
        </Row>

        <Row gutter={16} align="middle">
          <Col span={2} className="text-center">
            <CarOutlined className="text-2xl text-gray-400" />
          </Col>
          <Col span={22}>
            <p className="text-sm text-gray-500 mb-1"><GetLabel label="Modèle de voiture" /></p>
            <p className="text-lg font-semibold">{dataInput?.assets[0].assetmodel}</p>
          </Col>
        </Row>
      </div>


      {/* Date d'effet */}
      <FormInput name="effectdate" className="no-border-radius filter-item mb-10">
        <DatePicker
          name="effectDate"
          placeholder="JJ/MM/AAAA"
          className="no-border-radius mb-0 w-100"
          format="DD/MM/YYYY"
          value={form.getFieldValue('effectiveDate')}
          onChange={(date) => form.setFieldsValue({ effectiveDate: date })}
          disabledDate={(d) =>
            isBeforeDate(
              d,
              moment()
            )
          }
        />
      </FormInput>

      {/* Type de conversion */}

      <FormInput name="targetproductcode" className="no-border-radius filter-item mb-0">
        <ProductConversionRuleInput prcode={dataInput?.prcode} className='no-border-radius' />
      </FormInput>


      {/* VD Warning */}
      {/* {form.getFieldValue('conversionType') === 'VD' && (
        <div className="flex items-center gap-2 p-3 mb-4 bg-red-50 border border-red-200 rounded">
          <ExclamationCircleOutlined className='text-red-500' />
          <span className="text-red-600 text-sm">
            Le passage en VD entraîne un paiement de la TVA de 8 000€
          </span>
        </div>
      )} */}

      {/* Actions */}
      {/* <div className="flex justify-between mt-10">
        <div>
          {mode === 'modify' && (
            <ButtonLink
              className="ut-reset-btn ut-btn-no-border no-box-shadow mr-4 btn-supp"
              comcode="Suppdemande"
              onClick={() => !isInspect && setmodalVisibleDelet(true)}
              icon={<IBasket />}
            />
          )}
        </div>
        <Space>
          <ButtonLink
            className='ut-btn-bordred'
            comcode={mode === 'modify' ? 'Fermer' : 'Annuler'}
            onClick={() => setVisible(false)}
          />
          {mode === 'create' && (
            <ButtonLink
              comcode="Valider"
              type="primary"
              onClick={handleSubmit}
            />
          )}
        </Space>
      </div> */}

      {/* <ConfirmModal
        className="modalConfirmOrCancel"
        visible={modalVisibleDelet}
        status="error"
        message="Êtes-vous sûr de vouloir supprimer ces demandes ?"
        onConfirm={handleDelete}
        onCancel={() => !isInspect && setmodalVisibleDelet(false)}
        Confirmcomcode="valider"
        Cancelcomcode='close'
      /> */}
    </Form>
  );
};

export default ConversionModal;
